module.exports = __webpack_public_path__ + "media/assets/logo/Logo_FundoBranco_Agrosim_reduzido-9f2137ee60f8962e0497a6c1492df7ad.png";